import { useEffect, useState } from "react";
import { getReceivedPendingInvites } from "../../helpers/utils";
import useCurrentUser from "../../hooks/useCurrentUser";
import useInvites from "../../hooks/useInvites";
import useUsers from "../../hooks/useUsers";
import CollapsibleBlock from "../CollapsibleBlock/CollapsibleBlock";
import useCollapsibles from "../../hooks/useCollapsibles";
import Cards from "../Cards/Cards";

interface IReceivedInvitesList {
  columns?: number;
}

const ReceivedInvitesList: React.FC<IReceivedInvitesList> = ({
  columns = 1,
}) => {
  const { id: currentUserId } = useCurrentUser();
  const { collapsiblePreferences, updateCollapsible } = useCollapsibles();
  const { allInviteList } = useInvites();
  const { getUserById } = useUsers();

  const [pendingReceivedInvites, setPendingReceivedInvites] = useState<
    Array<any>
  >([]);

  useEffect(() => {
    setPendingReceivedInvites(
      getReceivedPendingInvites({
        invites: allInviteList?.data?.data?.data || [],
        user: currentUserId,
      })
    );
  }, [allInviteList?.data?.data?.data, currentUserId]);

  const getUserData = (_id: string) => {
    return getUserById({ _id }) || {};
  };

  if (!pendingReceivedInvites?.length) return null;

  return (
    <Cards columns={2}>
      {pendingReceivedInvites?.map?.((invite: any, key: number) => (
        <Cards.ContactInvite
          key={key}
          user={invite?.from}
          index={key}
          date={invite?.date.substring(0, 10)}
        />
      ))}
    </Cards>
  );
};

export default ReceivedInvitesList;
